<template>
  <div>

    <FrootWheelNavigation></FrootWheelNavigation>

    <br>
    <h4>FrootWheel set prize trigger</h4>

    <div class="row">

      <div class="col-3"></div>

      <div class="col-6">
        <table class="table table-striped table-bordered table-hovers">
          <tbody>
          <tr>

            <td>Start FW#<input
                type="text"
                id="start_number"
                class="form-control"
                :value="start_number"
                @input="start_number = $event.target.value">
            </td>

            <td>End FW#<input
                type="text"
                id="end_number"
                class="form-control"
                :value="end_number"
                @input="end_number = $event.target.value">
            </td>

            <td>Prize $<input
                type="text"
                id="win_dollar"
                class="form-control"
                :value="win_dollar"
                @input="win_dollar = $event.target.value">
            </td>

            <td>Shop Name<input
                type="text"
                id="shop_name"
                class="form-control"
                :value="shop_name"
                @input="shop_name = $event.target.value">
            </td>

            <td>
              <button @click="get_frootwheel_trigger_add_new()">Add Prize Trigger</button>
            </td>

          </tr>
          </tbody>
        </table>

        <template v-if="frootwheel_trigger_data.was_new_added === 1">
          <template v-if="frootwheel_trigger_data.has_error === 0">
            <h4 class="text-color-green">{{frootwheel_trigger_data.response_string}}</h4>
          </template>
          <template v-if="frootwheel_trigger_data.has_error === 1">
            <h4 class="text-color-red">{{frootwheel_trigger_data.response_string}}</h4>
          </template>
        </template>

      </div>

    </div>

    <h4>Active</h4>

    <div class="row">
      <table class="table table-striped table-bordered table-hovers">
        <thead>
        <tr>
          <th>Start FW#</th>
          <th>End FW#</th>
          <th>Dollar Amount</th>
          <th>Shop Name</th>
          <th>Date Added</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="active in frootwheel_trigger_data.active" v-bind:key="active.id">
          <td>{{active.start_number}}</td>
          <td>{{active.end_number}}</td>
          <td>${{active.firstscan_dollar}}</td>
          <td>{{active.shop_name}}</td>
          <td style="white-space:nowrap;">{{active.entrydate}}</td>
          <td><button @click="get_frootwheel_delete(active.id)">Delete</button></td>
        </tr>
        </tbody>
      </table>
    </div>

    <h4>Done</h4>
    <div class="row">
      <table class="table table-striped table-bordered table-hovers">
        <thead>
        <tr>
          <th>Start FW#</th>
          <th>End FW#</th>
          <th>Dollar Amount</th>
          <th>Shop Name</th>
          <th>Date Added</th>
          <th>Winner FW#</th>
          <th>Winner Date</th>
          <th>Spinned</th>
          <th>No Spin yet</th>
          <th>Total $</th>
          <th>First Scan</th>
          <th>Last Scan</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="done in frootwheel_trigger_data.done" v-bind:key="done.id">
          <td>{{done.start_number}}</td>
          <td>{{done.end_number}}</td>
          <td>${{done.firstscan_dollar}}</td>
          <td>{{done.shop_name}}</td>
          <td style="white-space:nowrap;">{{done.entrydate}}</td>
          <td>{{done.winner_number}}</td>
          <td style="white-space:nowrap;">{{done.winner_date}}</td>
          <td>{{done.codes_used}} / {{done.range_size}}</td>
          <td>{{done.codes_started}}</td>
          <td>{{done.win_dollar_sum}}</td>
          <td>{{done.first_scan}}</td>
          <td>{{done.last_scan}}</td>
          
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FrootWheelNavigation from '../../components/FrootWheelNavigation.vue';

export default {
  components: {
    FrootWheelNavigation
  },
  data() {
    return {
      start_number: '',
      end_number: '',
      win_dollar: '',
      shop_name: '',
    }
  },
  computed: {
    ...mapGetters({
      frootwheel_trigger_data: 'admin/frootwheel_trigger_data',
    }),
  },
  mounted() {
    this.get_frootwheel_triggers();
  },
  methods: {
    get_frootwheel_trigger_add_new() {
      this.$store.dispatch('admin/frootWheelTriggers', {is_new: 1, start_number: this.start_number, end_number: this.end_number, win_dollar: this.win_dollar, shop_name: this.shop_name} );
      this.start_number = '';
      this.end_number = '';
      this.win_dollar = '';
      this.shop_name = '';
    },
    get_frootwheel_triggers() {
      this.$store.dispatch('admin/frootWheelTriggers', {is_new: 0} );
    },
    get_frootwheel_delete(deleteid) {
      this.$store.dispatch('admin/frootWheelTriggers', {is_new: 2, delete_id: deleteid} );
    },
  }
}
</script>

<style>

.text-color-red {
  color:red;
}
.text-color-green {
  color:green;
}

</style>
